@let isDesktop = deviceService.isDesktop$ | async;
@let insideDialog = $insideDialog();

<!--  Тип заявки  -->
<ng-template #requestType let-isMobile="isMobile">
  @let requestTypeTitle = 'columns_filters.requestType' | translate;
  @if (requestTypeOptions.length > 1) {
    <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
      >{{
        isMobile && filterObject.requestType?.length ? requestTypeTitle : ''
      }}
      <tui-textfield
        multi
        tuiChevron
        [ngClass]="{
          'filter-input': !isMobile,
          'filter-input-mobile': isMobile,
        }"
        [stringify]="requestTypeStringifyFn"
        tuiTextfieldSize="m"
        tuiTextfieldAppearance="textfield"
        tuiDropdownLimitWidth="fixed"
        [title]="requestTypeTitle"
        (keydown.enter)="onFilterChange(filterType.requestType)"
      >
        @if (!isMobile) {
          <label tuiLabel>{{ requestTypeTitle }}</label>
        }
        <input
          [placeholder]="isMobile ? requestTypeTitle : ''"
          tuiInputChip
          tuiSelectLike
          [(ngModel)]="filterObject.requestType"
          (ngModelChange)="
            isDesktop && !insideDialog
              ? onFilterChange()
              : onFilterChange(filterType.requestType)
          "
        />
        <tui-input-chip *tuiItem />
        <tui-data-list *tuiDropdown>
          @for (type of requestTypeOptions; track type) {
            <button
              tuiOption
              [value]="type"
              [title]="requestTypeStringifyFn(type)"
            >
              {{ requestTypeStringifyFn(type) }}
            </button>
          }
        </tui-data-list>
      </tui-textfield>
    </label>
  }
</ng-template>

<!--  Статус заявки  -->
<ng-template #requestStatus let-isMobile="isMobile">
  @let requestStatus = 'columns_filters.request_status' | translate;

  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.requestStatus ? requestStatus : '' }}
    <tui-textfield
      tuiChevron
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      [tuiTextfieldCleaner]="true"
      [stringify]="requestStatusStringifyFn"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [title]="'columns_filters.choose_request_status' | translate"
      tuiDropdownLimitWidth="fixed"
      (keydown.enter)="onFilterChange(filterType.requestStatus)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ requestStatus }}</label>
      }
      <input
        [placeholder]="isMobile ? requestStatus : ''"
        tuiSelect
        [(ngModel)]="filterObject.requestStatus"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.requestStatus)
        "
      />
      <ng-template tuiDropdown>
        <tui-data-list size="s" tuiDropdownHover="false">
          @for (status of requestStatuses; track status.id) {
            <button tuiOption [value]="status" [title]="status.name">
              {{ 'request_statuses.' + status.id | translate }}
            </button>
          }
        </tui-data-list>
      </ng-template>
    </tui-textfield>
  </label>
</ng-template>
<!--  № заявки  -->
<ng-template #requestNumber let-isMobile="isMobile">
  @let requestNumber = 'columns_filters.request_number' | translate;

  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.requestNumber ? requestNumber : '' }}
    <tui-textfield
      class="min-w-[80px]"
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      [title]="requestNumber"
      (keydown.enter)="onFilterChange(filterType.requestNumber)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ requestNumber }}</label>
      }
      <input
        [placeholder]="isMobile ? requestNumber : ''"
        tuiInput
        [(ngModel)]="filterObject.requestNumber"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.requestNumber)
        "
      />
    </tui-textfield>
  </label>
</ng-template>
<!--  № проекта  -->
<ng-template #projectNumber let-isMobile="isMobile">
  @let projectNumber = 'columns_filters.project_number' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.projectNumber ? projectNumber : '' }}
    <tui-textfield
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      class="min-w-[125px]"
      [title]="projectNumber"
      (keydown.enter)="onFilterChange(filterType.projectNumber)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ projectNumber }}</label>
      }
      <input
        [placeholder]="isMobile ? projectNumber : ''"
        tuiInput
        [(ngModel)]="filterObject.projectNumber"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.projectNumber)
        "
      />
    </tui-textfield>
  </label>
</ng-template>
<!--  Договор  -->
<ng-template #contract let-isMobile="isMobile">
  @let contract = 'columns_filters.contract' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.contract ? contract : '' }}
    <tui-textfield
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      class="min-w-[125px]"
      [title]="contract"
      (keydown.enter)="onFilterChange(filterType.contract)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ contract }}</label>
      }
      <input
        [placeholder]="isMobile ? contract : ''"
        tuiInput
        [(ngModel)]="filterObject.contract"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.contract)
        "
      />
    </tui-textfield>
  </label>
</ng-template>
<!--  Марка/VIN/Заводской (ПЛ)   -->
<ng-template #carModelAndBrand let-isMobile="isMobile">
  @let car = 'columns_filters.car' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.carModelAndBrand ? car : '' }}
    <tui-textfield
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      [title]="car"
      (keydown.enter)="onFilterChange(filterType.carModelAndBrand)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ car }}</label>
      }
      <input
        [placeholder]="isMobile ? car : ''"
        tuiInput
        [(ngModel)]="filterObject.carModelAndBrand"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.carModelAndBrand)
        "
      />
    </tui-textfield>
  </label>
</ng-template>
<!--  Госномер   -->
<ng-template #carPlantNumber let-isMobile="isMobile">
  @let carPlantNumber = 'columns_filters.car_plant_number' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.carPlantNumber ? carPlantNumber : '' }}
    <tui-textfield
      [tuiTextfieldCleaner]="true"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      class="min-w-[125px]"
      [title]="carPlantNumber"
      (keydown.enter)="onFilterChange(filterType.carPlantNumber)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ carPlantNumber }}</label>
      }
      <input
        [placeholder]="isMobile ? carPlantNumber : ''"
        tuiInput
        [(ngModel)]="filterObject.carPlantNumber"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.carPlantNumber)
        "
      />
    </tui-textfield>
  </label>
</ng-template>
<!--  VIN   -->
<ng-template #vin let-isMobile="isMobile">
  @let vin = 'columns_filters.vin' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.vin ? vin : '' }}
    <tui-textfield
      [tuiTextfieldCleaner]="true"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      class="min-w-[125px]"
      [title]="vin"
      (keydown.enter)="onFilterChange(filterType.vin)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ vin }}</label>
      }
      <input
        [placeholder]="isMobile ? vin : ''"
        tuiInput
        [(ngModel)]="filterObject.vin"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.vin)
        "
      />
    </tui-textfield>
  </label>
</ng-template>
<!--  Лизингополучатель  -->
<ng-template #subjName let-isMobile="isMobile">
  @let subjName = 'columns_filters.subj_name' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.subjName ? subjName : '' }}
    <tui-textfield
      [tuiTextfieldCleaner]="true"
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      class="min-w-[125px]"
      [title]="subjName"
      (keydown.enter)="onFilterChange(filterType.subjName)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ subjName }}</label>
      }
      <input
        [placeholder]="isMobile ? subjName : ''"
        tuiInput
        [(ngModel)]="filterObject.subjName"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.subjName)
        "
      />
    </tui-textfield>
  </label>
</ng-template>

<!--  Адрес выдачи или название  -->
<ng-template #deliveryAddress let-isMobile="isMobile">
  @let deliveryAddress = 'columns_filters.delivery_address' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.deliveryAddress ? deliveryAddress : '' }}
    <tui-textfield
      [tuiTextfieldCleaner]="true"
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      class="min-w-[150px]"
      [title]="deliveryAddress"
      (keydown.enter)="onFilterChange(filterType.deliveryAddress)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ deliveryAddress }}</label>
      }
      <input
        [placeholder]="isMobile ? deliveryAddress : ''"
        tuiInput
        [(ngModel)]="filterObject.deliveryAddress"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.deliveryAddress)
        "
      />
    </tui-textfield>
  </label>
</ng-template>
<!-- Когда(дата и время) -->
<ng-template #releaseDatePeriod let-isMobile="isMobile">
  @let releaseDatePeriod = 'columns_filters.releaseDatePeriod' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.releaseDatePeriod ? releaseDatePeriod : '' }}
    <tui-textfield
      class="min-w-[195px]"
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      [title]="
        filterObject.releaseDatePeriod
          ? filterObject.releaseDatePeriod.getFormattedDayRange(
              'dd/mm/yyyy',
              '.'
            )
          : releaseDatePeriod
      "
      (keydown.enter)="onFilterChange(filterType.releaseDatePeriod)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ releaseDatePeriod }}</label>
      }
      <input
        [placeholder]="isMobile ? releaseDatePeriod : ''"
        tuiInputDateRange
        [(ngModel)]="filterObject.releaseDatePeriod"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.releaseDatePeriod)
        "
      />
      <tui-calendar-range *tuiDropdown [items]="dateRanges" />
    </tui-textfield>
  </label>
</ng-template>

<!-- Когда(дата) -->
<ng-template #releaseDate let-isMobile="isMobile">
  @let releaseDate = 'columns_filters.releaseDate' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.releaseDate ? releaseDate : '' }}
    <tui-textfield
      class="min-w-[120px]"
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      [title]="
        filterObject.releaseDate ? filterObject.releaseDate : releaseDate
      "
      (keydown.enter)="onFilterChange(filterType.releaseDate)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ releaseDate }}</label>
      }
      <input
        [placeholder]="isMobile ? releaseDate : ''"
        tuiInputDate
        [(ngModel)]="filterObject.releaseDate"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.releaseDate)
        "
      />
      <tui-calendar *tuiDropdown />
    </tui-textfield>
  </label>
</ng-template>

<!-- Когда(время) -->
<ng-template #releaseTime let-isMobile="isMobile">
  @let releaseTime = 'columns_filters.releaseTime' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.releaseTime ? releaseTime : '' }}
    <tui-textfield
      class="min-w-[100px]"
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      [title]="
        filterObject.releaseTime ? filterObject.releaseTime : releaseTime
      "
      (keydown.enter)="onFilterChange(filterType.releaseTime)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ releaseTime }}</label>
      }
      <input
        [placeholder]="isMobile ? releaseTime : ''"
        tuiInputTime
        [(ngModel)]="filterObject.releaseTime"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.releaseTime)
        "
      />
    </tui-textfield>
  </label>
</ng-template>
<!-- заказчики -->
<ng-template #counterparty let-isMobile="isMobile">
  @let selectCounterparty = 'columns_filters.select_counterparty' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.counterpartyOwner ? selectCounterparty : '' }}
    <tui-textfield
      [tuiTextfieldCleaner]="true"
      [stringify]="stringifyNameFn"
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [title]="selectCounterparty"
      tuiDropdownLimitWidth="fixed"
      (keydown.enter)="onFilterChange(filterType.counterpartyOwnerId)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ selectCounterparty }}</label>
      }
      <input
        [placeholder]="isMobile ? selectCounterparty : ''"
        tuiComboBox
        (input)="cpSearch = $any($event.target).value"
        [(ngModel)]="filterObject.counterpartyOwner"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.counterpartyOwnerId)
        "
      />
      <ng-template tuiDropdown>
        <tui-data-list size="s" tuiDropdownHover="false">
          @for (cp of filterCounterparty(cpSearch); track cp.id) {
            <button tuiOption [value]="cp" [title]="cp.name">
              <span class="x-font-body-5">{{ cp.name }}</span>
            </button>
          }
        </tui-data-list>
      </ng-template>
    </tui-textfield>
  </label>
</ng-template>
<!-- слс -->
<ng-template #installers let-isMobile="isMobile">
  @let selectInstaller = 'columns_filters.select_installer' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.installers?.length ? selectInstaller : '' }}
    <tui-textfield
      multi
      tuiChevron
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      [stringify]="stringifyFullNameOrGroupNameFn"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      tuiDropdownDirection="bottom"
      [rows]="5"
      class="installers-filter-multi-select"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ selectInstaller }}</label>
      }
      <input
        [placeholder]="isMobile ? selectInstaller : ''"
        tuiInputChip
        (input)="installerSearch = $any($event.target).value"
        [(ngModel)]="filterObject.installers"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.installers)
        "
      />
      <tui-input-chip *tuiItem />
      <tui-data-list *tuiDropdown #installersDropdownContent>
        @if (isDesktop && !insideDialog) {
          <div
            class="rounded-lg header-installers-filter-button p-3 top-0 sticky z-10"
          >
            <button
              appearance="primary"
              tuiButton
              type="button"
              class="w-full"
              size="s"
              (click)="onFilterChange(filterType.installers)"
            >
              {{ 'columns_filters.apply' | translate }}
            </button>
          </div>
        }
        <div>
          @if (installersGroups.length) {
            <tui-opt-group
              [label]="'columns_filters.installer_groups' | translate"
              tuiMultiSelectGroup
              class="x-font-body-4"
            >
              @for (group of installersGroups; track group) {
                <button tuiOption [value]="group">
                  <span>{{ group.name }}</span>
                </button>
              }
            </tui-opt-group>
            <hr />
          }
          <tui-opt-group
            [label]="'columns_filters.installers' | translate"
            tuiMultiSelectGroup
            class="x-font-body-4"
          >
            @for (
              installer of filterInstallers(installerSearch);
              track installer
            ) {
              <button tuiOption [value]="installer">
                {{ installer.fullName }}
              </button>
            }
          </tui-opt-group>
        </div>
      </tui-data-list>
    </tui-textfield>
  </label>
</ng-template>
<!--  Статус ОКК -->
<ng-template #qualityControlStatus let-isMobile="isMobile">
  @let qualityControlStatus =
    'columns_filters.select_quality_status_title' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{
      isMobile && filterObject.qualityControlStatus ? qualityControlStatus : ''
    }}
    <tui-textfield
      tuiChevron
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      [stringify]="qualityStatusStringifyFn"
      tuiDropdownLimitWidth="fixed"
      [title]="qualityControlStatus"
      (keydown.enter)="onFilterChange(filterType.qualityControlStatus)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ qualityControlStatus }}</label>
      }
      <input
        [placeholder]="isMobile ? qualityControlStatus : ''"
        tuiSelect
        [(ngModel)]="filterObject.qualityControlStatus"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.qualityControlStatus)
        "
      />
      <ng-template tuiDropdown>
        <tui-data-list size="s" tuiDropdownHover="false">
          @for (status of qualityControlStatuses; track status.id) {
            <button tuiOption [value]="status" [title]="status.name">
              {{ 'quality_statuses.' + status.id | translate }}
            </button>
          }
        </tui-data-list>
      </ng-template>
    </tui-textfield>
  </label>
</ng-template>

<!-- Создано через API  -->
<ng-template #createdViaApi let-isMobile="isMobile">
  @let createdViaApi = 'columns_filters.created_via_api' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.createdViaApi ? createdViaApi : '' }}
    <tui-textfield
      tuiChevron
      class="min-w-[150px]"
      [stringify]="booleanStringifyFn"
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      tuiDropdownLimitWidth="fixed"
      [title]="createdViaApi"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ createdViaApi }}</label>
      }
      <input
        [placeholder]="isMobile ? createdViaApi : ''"
        tuiSelect
        [(ngModel)]="filterObject.createdViaApi"
        (ngModelChange)="onFilterChange(filterType.createdViaApi)"
      />
      <ng-template tuiDropdown>
        <tui-data-list size="s" tuiDropdownHover="false">
          <button tuiOption [value]="true" title="да">
            {{ 'columns_filters.yes' | translate }}
          </button>
          <button tuiOption [value]="false" title="Нет">
            {{ 'columns_filters.no' | translate }}
          </button>
        </tui-data-list>
      </ng-template>
    </tui-textfield>
  </label>
</ng-template>

<!--  Опись подгружена -->
<ng-template #inventoryDocUploaded let-isMobile="isMobile">
  @let inventoryDocUploaded =
    'columns_filters.inventory_doc_uploaded' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{
      isMobile && filterObject.inventoryDocUploaded ? inventoryDocUploaded : ''
    }}
    <tui-textfield
      tuiChevron
      class="min-w-[150px]"
      [stringify]="booleanStringifyFn"
      tuiDropdownLimitWidth="fixed"
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      [title]="inventoryDocUploaded"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ inventoryDocUploaded }}</label>
      }
      <input
        [placeholder]="isMobile ? inventoryDocUploaded : ''"
        tuiSelect
        [(ngModel)]="filterObject.inventoryDocUploaded"
        (ngModelChange)="onFilterChange(filterType.inventoryDocUploaded)"
      />
      <ng-template tuiDropdown>
        <tui-data-list size="s" tuiDropdownHover="false">
          <button tuiOption [value]="true" title="да">
            {{ 'columns_filters.yes' | translate }}
          </button>
          <button tuiOption [value]="false" title="Нет">
            {{ 'columns_filters.no' | translate }}
          </button>
        </tui-data-list>
      </ng-template>
    </tui-textfield>
  </label>
</ng-template>

<!-- Лизинговый продукт  -->
<ng-template #leasingProduct let-isMobile="isMobile">
  @let leasingProduct = 'columns_filters.leasing_product' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.leasingProduct ? leasingProduct : '' }}
    <tui-textfield
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      class="min-w-[150px]"
      [title]="leasingProduct"
      (keydown.enter)="onFilterChange(filterType.leasingProduct)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ leasingProduct }}</label>
      }
      <input
        [placeholder]="isMobile ? leasingProduct : ''"
        tuiInput
        [(ngModel)]="filterObject.leasingProduct"
        (ngModelChange)="onFilterChange(filterType.leasingProduct)"
      />
    </tui-textfield>
  </label>
</ng-template>

<!-- Расширенная программа  -->
<ng-template #extendedProgram let-isMobile="isMobile">
  @let extendedProgram = 'columns_filters.extended_program' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.extendedProgram ? extendedProgram : '' }}
    <tui-textfield
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      class="min-w-[150px]"
      [title]="extendedProgram"
      (keydown.enter)="onFilterChange(filterType.extendedProgram)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ extendedProgram }}</label>
      }
      <input
        [placeholder]="isMobile ? extendedProgram : ''"
        tuiInput
        [(ngModel)]="filterObject.extendedProgram"
        (ngModelChange)="onFilterChange(filterType.extendedProgram)"
      />
    </tui-textfield>
  </label>
</ng-template>

<!-- Изготовитель (компания)  -->
<ng-template #manufacturerCompany let-isMobile="isMobile">
  @let manufacturerCompany = 'columns_filters.manufacturer_company' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{
      isMobile && filterObject.manufacturerCompany ? manufacturerCompany : ''
    }}
    <tui-textfield
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      class="min-w-[150px]"
      [title]="manufacturerCompany"
      (keydown.enter)="onFilterChange(filterType.manufacturerCompany)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ manufacturerCompany }}</label>
      }
      <input
        [placeholder]="isMobile ? manufacturerCompany : ''"
        tuiInput
        [(ngModel)]="filterObject.manufacturerCompany"
        (ngModelChange)="onFilterChange(filterType.manufacturerCompany)"
      />
    </tui-textfield>
  </label>
</ng-template>

<!-- Изготовитель (страна)  -->
<ng-template #manufacturerCountry let-isMobile="isMobile">
  @let manufacturerCountry = 'columns_filters.manufacturer_country' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{
      isMobile && filterObject.manufacturerCountry ? manufacturerCountry : ''
    }}
    <tui-textfield
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      class="min-w-[150px]"
      [title]="manufacturerCountry"
      (keydown.enter)="onFilterChange(filterType.manufacturerCountry)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ manufacturerCountry }}</label>
      }
      <input
        [placeholder]="isMobile ? manufacturerCountry : ''"
        tuiInput
        [(ngModel)]="filterObject.manufacturerCountry"
        (ngModelChange)="onFilterChange(filterType.manufacturerCountry)"
      />
    </tui-textfield>
  </label>
</ng-template>

<!-- Статус OBD  -->
<ng-template #obdStatus let-isMobile="isMobile">
  @let obdStatus = 'columns_filters.obd_status' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.obdStatus ? obdStatus : '' }}
    <tui-textfield
      tuiChevron
      class="min-w-[150px]"
      [stringify]="obdStatusStringifyFn"
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      tuiDropdownLimitWidth="fixed"
      [title]="obdStatus"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ obdStatus }}</label>
      }
      <input
        [placeholder]="isMobile ? obdStatus : ''"
        tuiSelect
        [(ngModel)]="filterObject.obdStatus"
        (ngModelChange)="onFilterChange(filterType.obdStatus)"
      />
      <ng-template tuiDropdown>
        <tui-data-list>
          @for (obdStatus of obdStatusesOptions; track obdStatus.id) {
            <button tuiOption [value]="obdStatus.id">
              {{ 'obd_statuses.' + obdStatus.id | translate }}
            </button>
          }
        </tui-data-list>
      </ng-template>
    </tui-textfield>
  </label>
</ng-template>

<!-- Заявка - Запрос на создание заявок  -->
<ng-template #isForCreateRequests let-isMobile="isMobile">
  @let isForCreateRequests =
    'columns_filters.is_for_create_request' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{
      isMobile && filterObject.isForCreateRequests ? isForCreateRequests : ''
    }}
    <tui-textfield
      tuiChevron
      class="min-w-[150px]"
      [stringify]="booleanStringifyFn"
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      tuiDropdownLimitWidth="fixed"
      [title]="isForCreateRequests"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ isForCreateRequests }}</label>
      }
      <input
        [placeholder]="isMobile ? isForCreateRequests : ''"
        tuiSelect
        [(ngModel)]="filterObject.isForCreateRequests"
        (ngModelChange)="onFilterChange(filterType.isForCreateRequests)"
      />
      <ng-template tuiDropdown>
        <tui-data-list size="s" tuiDropdownHover="false">
          <button tuiOption [value]="true" title="да">
            {{ 'columns_filters.yes' | translate }}
          </button>
          <button tuiOption [value]="false" title="Нет">
            {{ 'columns_filters.no' | translate }}
          </button>
        </tui-data-list>
      </ng-template>
    </tui-textfield>
  </label>
</ng-template>

<!--  Поставщик -->
<ng-template #deliveryName let-isMobile="isMobile">
  @let deliveryName = 'columns_filters.delivery_name' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.deliveryName ? deliveryName : '' }}
    <tui-textfield
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      [tuiTextfieldCleaner]="true"
      [title]="deliveryName"
      (keydown.enter)="onFilterChange(filterType.deliveryName)"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ deliveryName }}</label>
      }
      <input
        [placeholder]="isMobile ? deliveryName : ''"
        tuiInput
        [(ngModel)]="filterObject.deliveryName"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onFilterChange()
            : onFilterChange(filterType.deliveryName)
        "
      />
    </tui-textfield>
  </label>
</ng-template>

<!--Товары услуги -->
<ng-template #requestProduct let-isMobile="isMobile">
  @let requestProduct = 'columns_filters.request_product' | translate;
  <label [ngClass]="{ 'filter-input-mobile-label': isMobile }" tuiLabel
    >{{ isMobile && filterObject.products?.length ? requestProduct : '' }}
    <tui-textfield
      multi
      tuiChevron
      [ngClass]="{
        'filter-input': !isMobile,
        'filter-input-mobile': isMobile,
      }"
      [stringify]="productStringifyFn"
      tuiTextfieldSize="m"
      tuiTextfieldAppearance="textfield"
      tuiDropdownDirection="bottom"
      tuiDropdownLimitWidth="fixed"
      [rows]="5"
      [title]="requestProduct"
      class="installers-filter-multi-select"
    >
      @if (!isMobile) {
        <label tuiLabel>{{ requestProduct }}</label>
      }
      <input
        [placeholder]="isMobile ? requestProduct : ''"
        tuiInputChip
        (input)="productSearch = $any($event.target).value"
        [(ngModel)]="filterObject.products"
        (ngModelChange)="
          isDesktop && !insideDialog
            ? onProductsFilterModelChange()
            : onFilterChange(filterType.products)
        "
      />
      <tui-input-chip *tuiItem />
      <tui-data-list *tuiDropdown class="x-wide-filter-dropdown">
        <div
          #productsDropdownContent
          class="rounded-lg header-installers-filter-button p-3 top-0 sticky z-10"
        >
          @if (isDesktop && !insideDialog) {
            <button
              appearance="primary"
              tuiButton
              type="button"
              class="w-full"
              size="s"
              (click)="onFilterChange(filterType.products)"
            >
              {{ 'columns_filters.apply' | translate }}
            </button>
          }
        </div>

        <tui-opt-group
          [label]="'columns_filters.products' | translate"
          tuiMultiSelectGroup
          class="x-font-body-4"
        >
          @for (product of filterProducts(productSearch); track product.id) {
            <button tuiOption [value]="product" [title]="product.name">
              {{ product.name }}
            </button>
          }
        </tui-opt-group>
      </tui-data-list>
    </tui-textfield>
  </label>
</ng-template>

<!--Дата создания -->
<ng-template #createdAt>
  @let createdAt = 'columns_filters.created_at' | translate;
  <tui-textfield
    class="filter-input mt-1"
    tuiTextfieldSize="m"
    tuiTextfieldAppearance="textfield"
    [title]="createdAt"
  >
    <label tuiLabel>{{ createdAt }}</label>
    <input tuiInput ngModel="" [readOnly]="true" />
  </tui-textfield>
</ng-template>

<!--Дата обновления -->
<ng-template #updatedAt>
  @let updatedAt = 'columns_filters.updated_at' | translate;
  <tui-textfield
    class="filter-input mt-1"
    tuiTextfieldSize="m"
    tuiTextfieldAppearance="textfield"
    [title]="updatedAt"
  >
    <label tuiLabel>{{ updatedAt }}</label>
    <input tuiInput ngModel="" [readOnly]="true" />
  </tui-textfield>
</ng-template>

<!--Документы (Е-ПТС, ФОТО ПЛ) -->
<ng-template #docs>
  @let docs = 'columns_filters.docs' | translate;
  <tui-textfield
    class="filter-input mt-1"
    tuiTextfieldSize="m"
    tuiTextfieldAppearance="textfield"
    [tuiHint]="docs"
    [tuiHintShowDelay]="0"
  >
    <label tuiLabel>{{ docs }}</label>
    <input tuiInput ngModel="" [readOnly]="true" />
  </tui-textfield>
</ng-template>

@if (isDesktop && !insideDialog) {
  <!--  чекбокс выбрать все -->
  <th tuiTh class="w-[48px] p-0" [resizable]="true">
    <!--   Выбрать все  -->
    <input
      tuiCheckbox
      type="checkbox"
      [ngClass]="{ 'red-checkbox': $selectAllRequests() === undefined }"
      tuiCheckbox
      [(ngModel)]="$selectAllRequests"
      (ngModelChange)="onSelectAllRequests()"
      size="m"
    />
  </th>
  <!--  глаз (открыть в новой вкладке) -->
  <th tuiTh class="w-[45px] p-0! text-center!" [resizable]="true">
    <tui-icon icon="@tui.eye" class="size-6 text-base"></tui-icon>
  </th>
  @if (columnsTemplates) {
    @for (col of $desktopTableColumns(); track col) {
      <th
        tuiTh
        tuiResizable
        [style.width.px]="$desktopTableColumnsWidths()[col]"
      >
        <ng-container *ngTemplateOutlet="columnsTemplates[col]"></ng-container>
        <div
          class="absolute right-0 top-0 bottom-0 w-2"
          [tuiResizer]="[1, 0]"
          (tuiSizeChange)="onResized(col, $event)"
        ></div>
      </th>
    }
  }
} @else {
  <!-- МОБИЛА -->
  <section
    tuiAccordionItemContent
    class="w-full !x-white mt-4"
    tuiGroup
    orientation="vertical"
    [collapsed]="true"
  >
    <div class="mobile-filter-block">
      <p class="typo-body-m font-extrabold">
        {{ 'columns_filters.request' | translate }}
      </p>
      <!--  Тип заявки  -->
      <ng-container
        [ngTemplateOutlet]="requestType"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!--  Договор  -->
      <ng-container
        [ngTemplateOutlet]="contract"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!--  Марка/VIN/Заводской (ПЛ)   -->
      <ng-container
        [ngTemplateOutlet]="carModelAndBrand"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!--  Госномер   -->
      <ng-container
        [ngTemplateOutlet]="carPlantNumber"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!--  VIN   -->
      <ng-container
        [ngTemplateOutlet]="vin"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!--  № проекта  -->
      <ng-container
        [ngTemplateOutlet]="projectNumber"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!--  Статус заявки  -->
      <ng-container
        [ngTemplateOutlet]="requestStatus"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!--  № заявки  -->
      <ng-container
        [ngTemplateOutlet]="requestNumber"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!-- Когда -->
      <ng-container
        [ngTemplateOutlet]="releaseDatePeriod"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!--  Статус ОКК -->
      <ng-container
        [ngTemplateOutlet]="qualityControlStatus"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!--  Создано через API -->
      <ng-container
        [ngTemplateOutlet]="createdViaApi"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!--  Опись подгружена -->
      <ng-container
        [ngTemplateOutlet]="inventoryDocUploaded"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!--  Заявка - Запрос на создание заявок -->
      <ng-container
        [ngTemplateOutlet]="isForCreateRequests"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
    </div>
    <div class="mobile-filter-block mt-6">
      <p class="typo-body-m font-extrabold">
        {{ 'columns_filters.leasing_subject' | translate }}
      </p>
      <!--  Лизингополучатель  -->
      <ng-container
        [ngTemplateOutlet]="subjName"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!--  Адрес выдачи или название  -->
      <ng-container
        [ngTemplateOutlet]="deliveryAddress"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!--  Заказчик  -->
      <ng-container
        [ngTemplateOutlet]="counterparty"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!-- слс -->
      <ng-container
        [ngTemplateOutlet]="installers"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!-- Товары и услуги -->
      <ng-container
        [ngTemplateOutlet]="requestProduct"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!-- Лизинговый продукт -->
      <ng-container
        [ngTemplateOutlet]="leasingProduct"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!-- Расширенная программа -->
      <ng-container
        [ngTemplateOutlet]="extendedProgram"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!-- Изготовитель (компания) -->
      <ng-container
        [ngTemplateOutlet]="manufacturerCompany"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!-- Изготовитель (страна) -->
      <ng-container
        [ngTemplateOutlet]="manufacturerCountry"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
      <!-- Статус OBD -->
      <ng-container
        [ngTemplateOutlet]="obdStatus"
        [ngTemplateOutletContext]="{ isMobile: true }"
      ></ng-container>
    </div>
  </section>
}
